<swiper class="swiper-container" fxFlex="auto" [config]="bannerConfig" *ngIf="banners?.assets?.length">
    <div class="swiper-slide" *ngFor="let banner of banners.assets">
        <app-promotion [details]="banner"></app-promotion>
    </div>
</swiper>


<div [ngClass]="{'from-top': !banners?.assets?.length, 'ribbons-container': banners?.assets?.length }">
    <!-- Banner Ad -->
    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 pt-5 mx-auto" id="HOME_BANNER"></div>
        </div>
    </div>
    <app-ribbon [ribbon]="ribbon" *ngFor="let ribbon of ribbons"></app-ribbon>

    <!-- Banner Ad -->
    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 mx-auto" id="HOME_BANNER_BOTTOM"></div>
        </div>
    </div>
</div>